import { transformCatalogProductsLayeredPricesResponse, transformCatalogProductsLayeredResponse, transformCatalogProductsSortablesResponse } from '../products/transformers.js';
import { transformCatalogProductResponse } from '../transformers/product/index.js';

const transformCatalogProductsSearchLayeredPricesResponse = (data)=>transformCatalogProductsLayeredPricesResponse(data);
const transformCatalogProductsSearchLayeredResponse = (data)=>transformCatalogProductsLayeredResponse(data);
const transformCatalogProductsSearchSortablesResponse = (data)=>transformCatalogProductsSortablesResponse(data);
const transformCatalogProductsSuggestsResponse = (data)=>data;
const transformSearchIdentifiedAttributes = (header)=>{
    if (!header) {
        return null;
    }
    const attributes = JSON.parse(header);
    // header: {"attributes":[{"value":"nero","label":"COLOR"},{"value":"giallo","label":"COLOR"},{"value":"xl","label":"SIZE"}]}
    // result: [{attribute: 'color', values: ['nero', 'giallo']}, {attribute: 'size', values: ['xl']}]
    // remove duplicated values
    const result = attributes?.attributes?.reduce((acc, { label , value  })=>{
        const _label = label.toLowerCase();
        const found = acc.find((item)=>item.attribute === _label);
        if (found) {
            if (!found.values.includes(value)) {
                found.values.push(value);
            }
        } else {
            acc.push({
                attribute: _label,
                values: [
                    value
                ]
            });
        }
        return acc;
    }, []);
    return result;
};
const transformCatalogProductsSearchResponse = (data, headers)=>{
    return data.map((item)=>{
        item.inSearchContext = true;
        item.__bhSearchId = headers?.['x-search-id'] ?? null;
        item.__bhSearchIdentifiedAttributes = transformSearchIdentifiedAttributes(headers?.['x-search-identified-attributes']) ?? null;
        return transformCatalogProductResponse(item);
    });
};
const transformCatalogProductsSearchRecommendationFullResponse = ({ products , count , suggestions  }, headers)=>{
    return {
        products: products.map((item)=>{
            item.inSearchContext = true;
            item.__bhSearchId = headers?.['x-search-id'] ?? null;
            item.__bhSearchIdentifiedAttributes = transformSearchIdentifiedAttributes(headers?.['x-search-identified-attributes']) ?? null;
            return transformCatalogProductResponse(item);
        }),
        count: count.count,
        suggestions,
        __bhSearchId: headers?.['x-search-id'] ?? null,
        __bhSearchIdentifiedAttributes: transformSearchIdentifiedAttributes(headers?.['x-search-identified-attributes']) ?? null
    };
};

export { transformCatalogProductsSearchLayeredPricesResponse, transformCatalogProductsSearchLayeredResponse, transformCatalogProductsSearchRecommendationFullResponse, transformCatalogProductsSearchResponse, transformCatalogProductsSearchSortablesResponse, transformCatalogProductsSuggestsResponse };
